// extracted by mini-css-extract-plugin
export var addressFields = "_pb-0";
export var animationContainer = "_pb-1";
export var footer = "_pb-2";
export var lineItems = "_pb-3";
export var modalContent = "_pb-4";
export var orderName = "_pb-5";
export var strong = "_pb-6";
export var warning = "_pb-7";